<template>
  <div v-if="!mediaExpired">
    <div class="checkin__last-call mt-4 d-block d-md-flex align-items-center justify-content-between">
      <div class="mb-2 mb-md-0">
        <Icon name="infoCircle" width="20" class="mr-2"/>
        {{ message }}
      </div>
      <div class="text-right">
        <b-button size="sm" class="text-nowrap" variant="outline" @click="$bvModal.show('modal-last-chance-hd')">
          {{ $t('pages.checkins.media_deleting_btn2') }}
        </b-button>
      </div>
    </div>
    <ModalRetention :title="$t('pages.checkins.media_deleting_modal_title')"
                    :message="modalMessage"
                    :label-cta="$t('pages.checkins.media_deleting_modal_btn')" />
  </div>
</template>


<script>
import ModalRetention from "@/domain/checkin/ModalRetention.vue";

export default {
  name: "InfoMediaAvailable",
  components: {ModalRetention},
  props: {
    availableTo: {
      type: String,
      required: true
    },
    lastStayDeletionDate: {
      type: String,
      required: true
    }
  },
  computed: {
    availableToFormatted() {
      return this.$options.filters.formatDate(this.availableTo)
    },
    mediaExpired() {
      return new Date(this.availableTo) < new Date()
    },
    message() {
      return this.$t('pages.checkins.media_deleting_message', {date: this.availableToFormatted})
    },
    modalMessage() {
      const text = this.$t('pages.checkins.media_deleting_modal_message', {
        date: this.$options.filters.formatDate(this.availableTo, 'dddd L'),
        lastDate: this.$options.filters.formatDate(this.lastStayDeletionDate)
      })
      return this.$options.filters.capitalize(text)
    },

  },
}
</script>

<style scoped>

</style>